export const SERVER_URL = 'https://express-jugglingdb-articles-app.shamayko.ru/api/v1'; // eslint-disable-line import/prefer-default-export
